import React from 'react';
import { SearchIcon } from 'lucide-react';
interface EmptyStateProps {
  message?: string;
  submessage?: string;
}
export function EmptyState({
  message = 'No data matching this selection.',
  submessage = 'Clear filters or select another date range and try again.'
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-16 px-4" data-id="element-1918">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-1919">
        <SearchIcon size={32} className="text-gray-400" data-id="element-1920" />
      </div>
      <p className="text-sm font-medium text-gray-700 mb-1" data-id="element-1921">{message}</p>
      <p className="text-sm text-gray-500 text-center max-w-md" data-id="element-1922">{submessage}</p>
    </div>;
}